import React, { FC, ChangeEvent } from 'react';
import { useUniqueId } from '@hooks/useUniqueId';
import {
  CheckboxWrapper,
  Checkmark,
  Input,
  Label,
} from './Checkbox.elements';

const prefix = 'checkbox-'

type Props = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  size?: 'small' | 'big'
  idPrefix?: string
  ariaLabel?: string
}

export const Checkbox: FC<Props> = ({
  checked,
  label,
  onChange,
  size = 'big',
  idPrefix =  prefix,
  ariaLabel,
}) => {
  const id = useUniqueId(idPrefix)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return (
    <CheckboxWrapper>
      <Label htmlFor={id} size={size}>
        {label}
        <Input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          aria-label={ariaLabel}
        />
        <Checkmark size={size} />
      </Label>
    </CheckboxWrapper>
  );
}
